
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#AAB4C0","stroke-width":"1.202","stroke-linecap":"round","stroke-linejoin":"round","d":"M11.832 8.303H4.336"}}),_c('circle',{attrs:{"cx":"8.084","cy":"8.015","r":"7.413","stroke":"#AAB4C0","stroke-width":"1.202"}})])
          )
        }
      }
    